import _ from 'lodash';
import type { VxeTableProps } from 'vxe-table';

export const IS_PROD = process.env.NODE_ENV === 'production';

export const STAGE_FIRST_FIELD_LIST = [0, 1, 4, 7]
export const VXEGRID_OFFSET = -31
export const VXECELL_CLASS = '.vxe-cell'
export const VXEGRID_MAIN_WRAPPER_CLASS = '.vxe-table--main-wrapper'
export const VXEGRID_CELL_HEIGHT = 40

export const ROW_KEY = 'row_id'

export const STAGE_FIELDS = [['system_elements', 'sub_system', 'function'], ['failure_mode', 'effect', 'severity'], ['potential_cause_of_failure', 'occurrence', 'current_controls', 'detection', 'rpn', 'corrective_actions']]

export const GRID_PROJECT_FIELD = 'project'

export const GRID_FIELDS = _.flatten(STAGE_FIELDS)

export const GRID_PROJECT_RENDER = {
    slots: { default: 'project_default' },
}

export const GRID_BASIC_RENDER = {
    editRender: { autofocus: '.textarea-editor .vxe-textarea--inner' },
    slots: { default: 'text_default', edit: 'text_edit' },
}

export const GRID_NUM_RENDER = {
    editRender: { autofocus: '.num-editor .vxe-input--inner' },
    slots: { default: 'num_default', edit: 'num_edit' },
}

export const GRID_BASIC_OPTIONS: VxeTableProps = {
    round: true,
    size: 'small',
    height: 'auto',
    border: 'inner',
    autoResize: true,
    showOverflow: 'tooltip',
    keepSource: true,
    rowConfig: {
        isCurrent: true,
        keyField: ROW_KEY,
    },
    loading: false,
    mouseConfig: {
        selected: true,
    },
    scrollY: {
        enabled: true,
        gt: 0,
    },
    keyboardConfig: {
        isArrow: true,
    },
    columnConfig: { resizable: true },
}
